export default __webpack_public_path__ + "static/media/3193.84dac15d.png";